import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';

import DefaultModal from 'components/Modal/DefaultModal';
import Pagination from 'components/Pagination';
import ReactButton from 'components/Buttons/ReactButton';
import ReactLoader from 'components/Loader';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';
import { PhoneCell } from 'components/FlexTable/components/cells/phone';
import BroadcastListService from '../../../service';

const DEFAULT_PAGE_SIZE = 10;

const statusLabels = {
  enqueued: 'Na fila',
  sent: 'Enviado',
  delivered: 'Entregue',
  read: 'Lida',
  failed: 'Falhou',
  blocked: 'Bloqueado'
};

const BroadcastListResultsModal = ({
  isModalOpen,
  onModalToggle,
  broadcastListId,
  ...props
}) => {
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState([]);

  const handleGetResults = useCallback(
    (page = 1) => {
      if (!isModalOpen || !broadcastListId) return;
      setLoading(true);

      BroadcastListService.getResults(broadcastListId, {
        page,
        size: DEFAULT_PAGE_SIZE
      })
        .then((response) => {
          const data = response.data?.data?.result || [];
          const count = response.data?.data?.quantity || 0;
          setResults(Array.isArray(data) ? data : []);
          setQuantity(count);
        })
        .catch(() => {
          toast.error('Erro ao carregar resultados da campanha');
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [isModalOpen, broadcastListId]
  );

  useEffect(() => {
    if (isModalOpen) {
      setActivePage(1);
      handleGetResults(1);
    }
  }, [isModalOpen, handleGetResults]);

  const handlePageChange = (page) => {
    setActivePage(page);
    handleGetResults(page);
  };

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Resultados da Campanha"
      showCloseButton={false}
      modalContainerClasses="modal-xl"
      {...props}
    >
      <Row>
        <Col>
          <ToolkitProvider
            data={results}
            keyField="id"
            columns={[
              {
                dataField: 'cliente_nome',
                text: 'Cliente',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style
              },
              {
                dataField: 'cliente_telefone',
                text: 'Telefone',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => (
                  <PhoneCell
                    phone={row.cliente_telefone}
                    ddi={row.cliente_ddi}
                  />
                )
              },
              {
                dataField: 'ultima_msg_cliente',
                text: 'Resposta do Cliente',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => row.ultima_msg_cliente || '-'
              },
              {
                dataField: 'situacao',
                text: 'Situacao',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => row.situacao || '-'
              },
              {
                dataField: 'status_da_mensagem',
                text: 'Status da Mensagem',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) =>
                  statusLabels[row.status_da_mensagem] || '-'
              },
              {
                dataField: 'lead_id',
                text: 'Lead',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => row.lead_id || '-'
              },
              {
                dataField: 'opportunity_id',
                text: 'Oportunidade',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => row.opportunity_id || '-'
              }
            ]}
          >
            {(props) => (
              <div className="py-4 table-responsive">
                {loading ? (
                  <Row className="justify-content-md-center">
                    <ReactLoader />
                  </Row>
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    bootstrap4={true}
                    bordered={false}
                    classes="align-items-center"
                  />
                )}
              </div>
            )}
          </ToolkitProvider>
          {!!quantity && quantity > DEFAULT_PAGE_SIZE && (
            <Pagination
              activePage={activePage}
              totalItemsCount={quantity}
              onChange={handlePageChange}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col style={{ maxWidth: '8rem' }}>
          <ReactButton
            btnColor="confirmation"
            type="submit"
            size="sm"
            onClick={() => onModalToggle(false)}
            block
          >
            OK
          </ReactButton>
        </Col>
      </Row>
    </DefaultModal>
  );
};

export default BroadcastListResultsModal;
